import type { ComponentProps } from 'react'
import { SkeletonBox } from 'skullet/react'
import { cn } from '@/lib/utils'

/**
 * A fixed placeholder for content Skullet can't measure (a chart, an embed, an unknown count).
 * Content rendered from data belongs in skullet's `<Skeleton data sample>` instead.
 */
export function SkeletonBar({ className, style, ...props }: ComponentProps<'span'>) {
  return (
    <span data-slot="skeleton" className="contents" {...props}>
      {/* Empty sizes skip SkeletonBox's inline defaults, so the Tailwind classes size the bar. */}
      <SkeletonBox width="" height="" radius="" className={cn('rounded-md', className)} style={style} />
    </span>
  )
}
